import Vue from 'vue'
import axios from 'axios'

import store from '../store'

let isRefreshing = false
let failedRequestsQueue = []

// dev
// const baseURLHR = 'https://mis-api.cmu.ac.th/hr'
// const baseURLCard = 'https://mis-api.cmu.ac.th/reqcard'
// const baseURLCer = 'https://mis-api.cmu.ac.th/reqcert'
// const baseURLNoti = 'https://mis-api.cmu.ac.th/noti'
// const baseURLLineNoti =
//   'https://api.cmu.ac.th/mis/cmunotification/service/prod/api/'

// prod
const baseURLHR = 'https://api.cmu.ac.th/mis/hrportal'
const baseURLCard = 'https://api.cmu.ac.th/mis/hrreqcard'
const baseURLCer = 'https://api.cmu.ac.th/mis/hrreqcert'
const baseURLNoti = 'https://api.cmu.ac.th/mis/hrnoti/prod/v1'
const baseURLLineNoti =
  'https://api.cmu.ac.th/mis/cmunotification/service/prod/api/'

const axiosHrClient = axios.create({
  baseURL: baseURLHR + localStorage.getItem('endpointChannel'),
  timeout: 30000
})
Vue.prototype.axiosHrClient = axiosHrClient

const axiosReqCardClient = axios.create({
  baseURL: baseURLCard + localStorage.getItem('endpointChannel'),
  timeout: 30000
})
Vue.prototype.axiosReqCardClient = axiosReqCardClient

const axiosReqCardClient60s = axios.create({
  baseURL: baseURLCard + localStorage.getItem('endpointChannel'),
  timeout: 60000
})
Vue.prototype.axiosReqCardClient60s = axiosReqCardClient60s

const axiosReqCerClient = axios.create({
  baseURL: baseURLCer + localStorage.getItem('endpointChannel'),
  timeout: 30000
})
Vue.prototype.axiosReqCerClient = axiosReqCerClient

const axiosNotiClient = axios.create({
  baseURL: baseURLNoti,
  timeout: 30000
})
Vue.prototype.axiosNotiClient = axiosNotiClient

const axiosLineNotiClient = axios.create({
  baseURL: baseURLLineNoti,
  timeout: 30000
})
Vue.prototype.axiosLineNotiClient = axiosLineNotiClient

//  เรียก setup interceptors
setupAxiosInterceptors(axiosHrClient)
setupAxiosInterceptors(axiosReqCardClient)
setupAxiosInterceptors(axiosReqCardClient60s)
setupAxiosInterceptors(axiosReqCerClient)
setupAxiosInterceptors(axiosNotiClient)
setupAxiosInterceptors(axiosLineNotiClient)

async function refreshAccessToken() {
  try {
    const tokenEndpoint = `https://api.cmu.ac.th/mis/hrportal/prod/callback`

    const response = await axios.post(tokenEndpoint, {
      refresh_token: localStorage.getItem('refreshtoken')
    })

    const newAccessToken = response.data.accessToken
    localStorage.setItem('accesstoken', newAccessToken)
    localStorage.setItem('refreshtoken', response.data.refreshToken)

    // แก้ header สำหรับ axios instance
    axiosHrClient.defaults.headers.common[
      'Authorization'
    ] = `Bearer ${newAccessToken}`
    axiosReqCardClient.defaults.headers.common[
      'Authorization'
    ] = `Bearer ${newAccessToken}`
    axiosReqCerClient.defaults.headers.common[
      'Authorization'
    ] = `Bearer ${newAccessToken}`
    axiosNotiClient.defaults.headers.common[
      'Authorization'
    ] = `Bearer ${newAccessToken}`
    axiosLineNotiClient.defaults.headers.common[
      'Authorization'
    ] = `Bearer ${newAccessToken}`

    // Resolve all queued requests
    failedRequestsQueue.forEach(cb => cb.resolve(newAccessToken))
    failedRequestsQueue = []
  } catch (error) {
    failedRequestsQueue.forEach(cb => cb.reject(error))
    failedRequestsQueue = []
    throw error
  } finally {
    isRefreshing = false
  }
}

function setupAxiosInterceptors(client) {
  client.interceptors.response.use(
    response => response,
    error => {
      const originalRequest = error.config

      if (error.response?.status === 401 && !originalRequest._retry) {
        originalRequest._retry = true

        if (!isRefreshing) {
          isRefreshing = true
          refreshAccessToken().catch(err => {
            // handle error ถ้า refresh ไม่ได้
            store.commit('error/set_error_visible', {
              visible: true,
              errorCode: 401,
              message: 'Session expired' + err.message
            })
          })
        }

        return new Promise((resolve, reject) => {
          failedRequestsQueue.push({
            resolve: token => {
              originalRequest.headers['Authorization'] = `Bearer ${token}`
              resolve(client(originalRequest))
            },
            reject: err => {
              reject(err)
            }
          })
        })
      }

      // แจ้ง error ถ้าไม่ใช่ 401
      store.commit('error/set_error_visible', {
        visible: true,
        errorCode: error.response?.status || 500,
        message: error.response.message
      })

      // ถ้าไม่ใช่ 401 หรือ retry แล้ว
      return Promise.reject(error)
    }
  )
}

export {
  axiosHrClient,
  axiosReqCardClient,
  axiosReqCerClient,
  axiosNotiClient,
  axiosReqCardClient60s,
  axiosLineNotiClient
}
